export function toggleFooterDropdown() {
  $(document).ready(function() {
    var accordionContainer = $(".footer__column");
    var accordionExpandableItem = ".footer__list";
    accordionContainer.click(function() {
      $(this)
        .children(accordionExpandableItem)
        .slideToggle();
    });
  });
}
